import { ShakerOutlineIcon } from './ShakerOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 1A2E13B0-421D-460F-87C2-63C1DEC6525A
 * name shaker-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shaker-outline.svg
 * tags
 * - Food / Drink 
 */
export const SaltIcon = ShakerOutlineIcon;
export default SaltIcon